import { render, staticRenderFns } from "./WhatsappUnofficial.vue?vue&type=template&id=4c06aa71&"
import script from "./WhatsappUnofficial.vue?vue&type=script&lang=js&"
export * from "./WhatsappUnofficial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports